import type { RootState } from 'src/app/store/types';

export function selectTripCreateEvents(state: RootState) {
  return state.tripSummary.tripCreateEvents;
}
